export default __webpack_public_path__ + "static/download-image-1-d5b0cc0588fb4da2f79fbf01e5cbaf90.png";